export default "__VITE_ASSET__b5684d5a__"